// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WOlS","delete":"styles_delete__GCs2A","update":"styles_update__298OH","add":"styles_add__3vbmY"};